module.exports = __webpack_public_path__ + "static/milkshake-6bbb7e44a8896daf696e226b6266235a.gif";